import { render, staticRenderFns } from "./SlottedEditListItem.vue?vue&type=template&id=23245a03&scoped=true&"
import script from "./SlottedEditListItem.vue?vue&type=script&lang=js&"
export * from "./SlottedEditListItem.vue?vue&type=script&lang=js&"
import style0 from "./SlottedEditListItem.vue?vue&type=style&index=0&id=23245a03&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23245a03",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VCard,VListItem})
